export default __webpack_public_path__ + "static/media/Concepto jurídico ABC Estilo Militar Colombiano.f21e409d.pdf";